let els;

const scale = function () {
    for (let i = 0; i < els.length; i += 1) {
        const width = els[i].getAttribute("width");
        const height = els[i].getAttribute("height");
        const ratio = width / height;
        let parentWidth = els[i].parentElement.offsetWidth;
        if (els[i].parentNode.getAttribute("data-width-factor") != undefined) {
            parentWidth =
                parentWidth *
                els[i].parentNode.getAttribute("data-width-factor");
        }
        els[i].style.width = `${parentWidth}px`;
        if (els[i].classList.contains("tickets-frame")) {
            els[i].style.height = `${parentWidth * 2}px`;
        } else {
            els[i].style.height = `${parentWidth / ratio}px`;
        }
    }
    if (init) {
        for (let i = 0; i < els.length; i += 1) {
            if (els[i].closest("[data-hide-frames]")) {
                els[i].closest("[data-hide-frames]").style.display = "none";
            }
        }
        init = false;
    }
};

let init = true;
export const iframeEnhancer = function (el) {
    els = el.querySelectorAll("iframe");
    scale();
    window.addEventListener("resize", scale);
};
